<template>
  <div class="main-container middle dir-column" :style="'background-image: url('+userProfile.backgroundImage+')'">
      <h1 class="page-title">Edit Profile</h1>
      <div class="profile flex dir-column ai-center">
          <img class="profile-image" :src="userProfile.profileImage" :alt="userProfile.username">
          <div class="row">
              <p>Username</p>
              <input type="text" v-model="userProfile.username" />
          </div>
          <div class="row">
              <p>Profile image URL</p>
              <input type="text" v-model="userProfile.profileImage" />
          </div>
          <div class="row">
              <p>Background image URL</p>
              <input type="text" v-model="userProfile.backgroundImage" />
          </div>
          <div class="row">
              <p>Instagram</p>
              <input type="text" v-model="userProfile.accounts.instagram" />
          </div>
          <div class="row">
              <p>Twitch</p>
              <input type="text" v-model="userProfile.accounts.twitch" />
          </div>
          <div class="row">
              <p>Youtube</p>
              <input type="text" v-model="userProfile.accounts.youtube" />
          </div>
          <div class="row">
              <p>Twitter</p>
              <input type="text" v-model="userProfile.accounts.twitter" />
          </div>
          <div class="row">
              <p>Website</p>
              <input type="text" v-model="userProfile.accounts.website" />
          </div>
          <div class="row">
              <button @click="setProfile">
                  Güncelle
              </button>
          </div>
          <div class="row error-container" v-if="errors.length != 0">
            <p class="error-text" v-for="(item, index) in errors" :key="index" >
                {{ index+1 }}. {{ item }}
            </p>
            <i class="fas fa-times close-error" @click="closeError"></i>
          </div>
          <div class="go-back jc-between">
              <h1 @click="$router.go(-1)">
                  <i class="fas fa-undo-alt"></i>
                  Go Back
              </h1>
              <h1 @click="logOut">
                  Log Out 
                  <i class="fas fa-sign-out-alt"></i>
              </h1>
          </div>
      </div>
  </div>
</template>

<script>
import Cookies from 'js-cookie';
import UserService from '../services/userService';

export default {
    name: 'EditProfile',
    data() {
        return {
            currentUserId: '',
            currentUsername: '',
            userProfile: {
                username: '',
                profileImage: '',
                backgroundImage: '',
                accounts: {
                    instagram: '',
                    twitter: '',
                    twitch: '',
                    website: '',
                    youtube: ''
                }
            },
            errors: []
        }
    },
    async created() {
        await this.getProfile();
    },
    methods: {
        async getProfile() {
            this.currentUserId = Cookies.get('user-id');

            if (!this.currentUserId) {
                this.$router.push('/login');
            }

            const userProfile = await UserService.getProfileSettings({ userId: this.currentUserId });

            if (userProfile.status == 400) {
                this.$router.push('/login');
            }

            this.userProfile = userProfile.data.user;
            this.currentUsername = this.userProfile.username;
        },
        async setProfile() {
            this.closeError();
            if (this.userProfile.username.length < 3) {
                this.errors.push('Username must be longer than 3.');
                return;
            }

            if (this.userProfile.username.includes(' ')) {
                this.errors.push('Username can\'t contain space.');
                return;
            }

            if(this.currentUsername != this.userProfile.username) {
                const isUsernameValid = await UserService.getProfile(this.userProfile.username);
                
                if(isUsernameValid.status == 200) {
                    this.errors.push('Username already taken.');
                    return;
                }
            }

            const result = await UserService.setProfileSettings({ user: this.userProfile });
            if (result.status == 200) {
                this.errors.push('Update Successfully!');
                setTimeout(() => {
                    this.$router.push('/p/'+this.userProfile.username);
                }, 1000);
            }
        },
        closeError() {
            this.errors = [];
        },
        logOut() {
            Cookies.set('user-id','');
            this.$router.push('/');
        }
    }
}
</script>

<style scoped>

.main-container {
    width: 100%;
    padding-block: 100px;
    background-color: white;
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    background-attachment: fixed;
}

.profile {
    width: 500px;
    padding: 60px 25px;
    box-shadow: 2px 2px 5px 1px rgba(0,0,0,.1);
    position: relative;
    background-color: white;
}

.profile-image {
    width: 150px;
    height: 150px;
    margin-bottom: 25px;
    border-radius: 50%;
}

.row p {
    font-family: 'Poppins' , sans-serif;
}

.go-back {
    font-family: 'Poppins' , sans-serif;
    font-size: 10px;
    position: absolute;
    top: 0px;
    left: 0px;
    padding: 10px;
    width: 100%;
}

.go-back h1 {
    cursor: pointer;
    position: relative;
}

.go-back h1::before {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 0;
    width: 0%;
    height: 2px;
    transition: all .3s ease;
    background-color: black;
    filter: opacity(0%);
}

.go-back h1:hover::before {
    width: 100%;
    filter: opacity(100%);
}

.go-back h1 i {
    margin-right: 10px;
}

.page-title {
    font-size: 50px;
    font-family: 'Poppins' , sans-serif;
    font-weight: 500;
    margin-bottom: 15px;
    color: white;
    -webkit-text-stroke: 2px black;
}

</style>